// extracted by mini-css-extract-plugin
module.exports = {"p":"Pb-module--p--10r3J"};